import {Text} from 'components';

export const WorkTitle: React.FC = () => {
  return (
    <Text kind="primary" variant="body2" sx={{fontWeight: 'bold'}}>
      {'Work'}
    </Text>
  );
};
